import { render } from "./CustomOrderDeleteModal.vue?vue&type=template&id=4f3b8b5c"
import script from "./CustomOrderDeleteModal.vue?vue&type=script&lang=js"
export * from "./CustomOrderDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomOrderDeleteModal.vue"]])

export default __exports__